import { render, staticRenderFns } from "./PromotionEdit.vue?vue&type=template&id=8c5a4d02"
import script from "./PromotionEdit.vue?vue&type=script&lang=js"
export * from "./PromotionEdit.vue?vue&type=script&lang=js"
import style0 from "./PromotionEdit.vue?vue&type=style&index=0&id=8c5a4d02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports